module.exports = {
  environment: 'development',
  baseURL: 'localhost:3000',
  gaTrackingId: 'UA-150413471-1',
  freshchatToken: '280c5add-ea4f-4ddf-8628-77dfae44661d',
  // apiURL: 'https://api.rupiahtoken.co.id',
  apiURL: 'https://staging-api-178.rupiahtoken.com',
  firebase: {
    apiKey: 'AIzaSyDXZKyy99hoe5DL9LCUsIaDqiuVVMOgw2A',
    authDomain: 'rupiahtoken-staging.firebaseapp.com',
    databaseURL: 'https://rupiahtoken-staging.firebaseio.com',
    projectId: 'rupiahtoken-staging',
    storageBucket: 'rupiahtoken-staging.appspot.com',
    messagingSenderId: '56608955860',
    appId: '1:56608955860:web:7f2760391af28afa'
  }
};
